<template>
    <div v-if="!loading">
        <h3 class="mb-2 text-primary mt-50">گزارش اشتراک</h3>
        <b-card class="p-0" no-body>
            <b-overlay :show="loadingPage" variant="transparent" opacity="1" blur="3px" rounded="sm">
                <b-table responsive :items="history" :fields="fields" class="mb-0">
                    <template #cell(createdAt)="data">
                        {{ new Date(data.item.createdAt).toLocaleDateString('fa-IR') }}
                    </template>
                    <template #cell(status)="data">
                        {{ storeSubscriptionStatus(data.item.status) }}
                    </template>
                    <template #cell(startedAt)="data">
                        {{ data.item.startedAt ? new Date(data.item.startedAt).toLocaleDateString('fa-IR') : '-' }}
                    </template>
                    <template #cell(isUpgrade)="data">
                        {{ data.item.isUpgrade ? 'ارتقاء' : 'تمدید' }}
                    </template>
                    <template #cell(trackingNumber)="data">
                        {{ data.item.trackingNumber == 0 ? '-' : data.item.trackingNumber }}
                    </template>
                    <template #cell(totalDays)="data">
                        {{ data.item.totalDays }} روز
                    </template>
                    <template #cell(expiredAt)="data">
                        {{ data.item.expiredAt ? new Date(data.item.expiredAt).toLocaleDateString('fa-IR') : '-' }}
                    </template>
                    <template #cell(bankTransactionCode)="data">
                        {{ data.item.bankTransactionCode ? data.item.bankTransactionCode : '-' }}
                    </template>
                    <template #cell(price)="data">
                        {{ data.item.price == 0 ? 'رایگان' : data.item.price.toLocaleString('fa-IR') }}
                    </template>
                </b-table>
            </b-overlay>
        </b-card>
        <b-pagination align="center" @input="getSubscriptionHistory" v-model="parameters.pageIndex"
            :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />
    </div>
</template>

<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BTable, BPagination, BOverlay } from 'bootstrap-vue';
import { storeService } from '@core/services';

export default {
    components: {
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BPagination,
        BOverlay
    },
    data() {
        return {
            loadingPage: false,
            loading: true,
            history: [],
            fields: [
                {
                    key: 'title',
                    label: 'نام اشتراک',
                },
                {
                    key: 'isUpgrade',
                    label: 'نوع',
                },
                {
                    key: 'createdAt',
                    label: 'تاریخ',
                },
                {
                    key: 'price',
                    label: 'مبلغ (ریال)',
                },
                {
                    key: 'totalDays',
                    label: 'تعداد روزها',
                },
                {
                    key: 'status',
                    label: 'وضعیت',
                },
                {
                    key: 'trackingNumber',
                    label: 'شماره پیگیری',
                },
                {
                    key: 'startedAt',
                    label: 'شروع اشتراک',
                },
                {
                    key: 'expiredAt',
                    label: 'پایان اشتراک',
                },
            ],
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                totalCount: null
            }
        }
    },
    computed: {
        storeSubscriptionStatus() {
            return (status) => {
                if (status == 0) {
                    return 'پرداخت نشده'
                }
                if (status == 1) {
                    return 'پرداخت ناموفق'
                }
                if (status == 2) {
                    return 'رزرو شده'
                }
                if (status == 3) {
                    return 'فعال'
                }
                if (status == 4) {
                    return 'منقضی شده'
                }
            }
        },
    },
    methods: {
        getSubscriptionHistory() {
            this.loadingPage = true
            storeService.subscriptionHistory(this.storeId, this.parameters).then(({ data }) => {
                this.parameters.totalCount = data.totalCount
                this.history = data.items
                this.loadingPage = false
                this.loading = false
            })
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        this.getSubscriptionHistory()
    },
};
</script>